module.exports = __webpack_public_path__ + "static/media/hindi.5ac494da.svg";